import { FilterValue } from '@/catalog/types/filterValue';

export type MetricGradeMarks = Record<number, StringOrNumber>;

export function getMarksLength(marks: MetricGradeMarks): number {
  return Object.values(marks).filter((mark) => !!mark).length;
}

export function getMarkByValue(marks: MetricGradeMarks, value: Nullable<number>, min: number): Nullable<number> {
  if (value === null) {
    return null;
  }

  const marksLength = getMarksLength(marks);
  const mark = value * marksLength;

  if (mark > marksLength) {
    return marksLength;
  }

  if (mark < min) {
    return min;
  }

  return mark;
}

export function getValuesFromSliderRange(
  marks: MetricGradeMarks,
  sliderRange: number[],
  min: number,
  max: number,
): FilterValue {
  const [sliderMin, sliderMax] = sliderRange;
  const marksLength = getMarksLength(marks);

  let from: Nullable<number> = null;
  let to: Nullable<number> = null;

  if (Number.isFinite(sliderMin)) {
    let minValue = sliderMin / marksLength;

    if (minValue < min) {
      minValue = min;
    } else if (minValue > max) {
      minValue = max;
    }

    /*
     * If "minValue" equals to "min" - do not update it,
     * it will mean default value and we do not send default value to backend
     * */
    if (minValue !== min) {
      from = minValue;
    }
  }

  if (Number.isFinite(sliderMax)) {
    let maxValue = sliderMax / marksLength;

    if (maxValue < min) {
      maxValue = min;
    } else if (maxValue > max) {
      maxValue = max;
    }

    /*
     * If "maxValue" equals to "max" - do not update it,
     * it will mean default value and we do not send default value to backend
     * */
    if (maxValue !== max) {
      to = maxValue;
    }
  }

  return { from, to };
}
